import { toast } from 'react-toastify';

const showToastSuccess = (message) => {
  toast.success(message, {
    autoClose: 5000
  });
};

const showToastFailure = (message) => {
  toast.error(message, {
    autoClose: 5000
  });
};

export { showToastSuccess, showToastFailure };
